import {
	AlertCircle,
	CircleCheck,
	CircleX,
	InfoCircle
} from 'tabler-icons-react';
import styles from 'partials/toastify-message.module.scss';

export const ToastifyMessage = ({ message, type }) => {
	const getIconByType = () => {
		const types = {
			error: CircleX,
			success: CircleCheck,
			warning: AlertCircle,
			info: InfoCircle
		};
		const Icon = types[type];
		return <Icon size={26} className={styles.icon} />;
	};

	return (
		<div className={styles.box}>
			<div className={styles.iconBox}>{getIconByType()}</div>
			<div className={styles.message}>{message}</div>
		</div>
	);
};
